export default "__VITE_ASSET__COCv4$HL__"